import styled from 'styled-components'

export const StyledContainer = styled.div`
  padding-bottom: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding-bottom: 0;
  }
`
